'use strict';

// Constructor
export class WarningNotice {
    constructor() {
        var $banners = $('#block-views-block-website-blocks-warning-notice .warning-notice');
        $banners.each(function(i,banner){
            
            var $banner = $(banner);
            var $html = $banner.html();
            var $text = $banner.text();
            var $datehash = hashCode($banner.children('.date').text());
            var $hash = hashCode($text);
            var $cookie = 'cookie_agreement_'+$datehash;

            if (getCookie($cookie) != $hash) {
                // Add the banner to body
                showCookieBanner($banner)
            }

            // Closing the cookie without agreeing
            $banner.on('click', '.close', function ($event) {
                $event.preventDefault();
                setCookie($cookie, $hash, 365); // Set the cookie for 365 days
                hideCookieBanner($banner);
            });

            // Accepting the cookie
            $('body').on('click', '.close-cookie', function ($event) {
                $event.preventDefault();
                hideCookieBanner($banner);
            });
        });

        function hideCookieBanner($banner) {
            $banner.removeClass('visible');
        }

        function showCookieBanner($banner) {
            $banner.addClass('visible');
        }

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function hashCode(s) {
            var h = 0, l = s.length, i = 0;
            if (l > 0)
                while (i < l)
                    h = (h << 5) - h + s.charCodeAt(i++) | 0;
            return h;
        };
    }
}